export default "__VITE_ASSET__jqWp27UG__"